module.exports = __webpack_public_path__ + "img/video-3-tmb.afef8c93.png";